import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { RadioButton } from "primereact/radiobutton";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import Loader from "../../Components/Loader";
import storage from "../../Services/Storage";
import {
    createAPIEndpointServiceInvoice,
    EndpointServiceInvoice,
} from "../../Services/ServiceInvoice/ServiceInvoiceService";
import { toast } from "react-toastify";
import Information from "./Information";
import Axios from "../../api/Axios";
import { format, parse } from "date-fns";
import ServiceInvoice from "./ServiceInvoice";
import { Dialog } from "primereact/dialog";

const ServiceInvoiceDetails = () => {
    const auth = storage.getLocal("user");
    const [searchParams] = useSearchParams();
    const tag = searchParams.get("tag");
    const invhId = searchParams.get("id");
    const startdate = new Date(searchParams.get("startDate"));
    const enddate = new Date(searchParams.get("endDate"));
    const [strType, setStrType] = useState(tag == "N" ? "N" : tag == "R" ? "R" : "S");
    const [supplierData, setSupplierData] = useState();
    const [supplierName, setSupplierName] = useState();
    const [loading, setLoading] = useState(false);
    const [prevRSE, setPrevRSE] = useState(false);
    const [confirmSaveRSEPopup, setConfirmSaveRSEPopup] = useState(false);
    const [disable, setDisable] = useState(false);
    const [supplierGstnNo, setSupplierGstnNo] = useState();
    const [supplierGstnNoService, setSupplierGstnNoService] = useState();
    const [selectedSupplier, setSelectedSupplier] = useState();
    const [selectedSupplierService, setSelectedSupplierService] = useState();
    const [SSRData, setSSRData] = useState();
    const [SSRName, setSSRName] = useState();
    const [selectedSSR, setSelectedSSR] = useState();
    const [invoiceNo, setInvoiceNo] = useState();
    const [prevRSEInv, setPrevRSEInv] = useState([]);
    const [selectedSSRdetails, setSelectedSSRdetails] = useState([]);
    const [RSEName, setRSEName] = useState("");
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const nav = useNavigate();
    const [endDate, setEndDate] = useState(new Date());
    const [invoiceDate, setInvoiceDate] = useState(
        new Intl.DateTimeFormat("en-GB").format(new Date())
    );
    const [showDialog, setShowDialog] = useState(false);
    const [showGST, setShowGST] = useState(false);
    const [allRecordsData, setAllRecordsData] = useState([]);
    const [servicedataSave, setServicedataSave] = useState(false);
    const [invoiceSSRCount, setInvoiceSSRCount] = useState();
    const [showInvoice, setShowInvoice] = useState(false);
    const [printData, setPrintData] = useState({});
    const [InvhId, setInvhId] = useState([]);
    const [Tag, setTag] = useState("");



    const getSSRData = async () => {
        try {
            const response = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.PopulateSSR}?UserId=${auth.UserId}`
            );
            setSSRData(response.data.Data);
        } catch (error) {
            console.log("error ", error);
        }
    };

    const getSupplierData = async () => {
        try {
            const response = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.PopulateSupplier}?UserId=${auth.UserId}&CompId=${auth.CompId}`
            );
            setSupplierData(response.data.Data);
        } catch (error) {
            console.log("error ", error);
        }
    };
    const getRSEData = async () => {
        try {
            const response = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.PopulateRSESupplier}?UserId=${auth.UserId}&CompId=${auth.CompId}`
            );
            setSupplierData(response.data.Data);
        } catch (error) {
            console.log("error ", error);
        }
    };
    // let suppdata
    const getSupplierDataforService = async () => {
        try {
            const response = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.PopulateSupplier}?UserId=${auth.UserId}&CompId=${auth.CompId}`
            );
            setSupplierData(response.data.Data);
            for (let i = 0; i <= response.data.Data.length - 1; i++) {
                let strVal = response.data.Data[i].MASK_SUPP_ID;
                if (strVal.toString().includes("|000|SERVICE")) {
                    setSelectedSupplierService(response.data.Data[i]);
                    setSupplierGstnNoService("27AAACC4481E2ZU");
                    setSelectedSupplier(response.data.Data[i]);
                }
            }
        } catch (error) {
            console.log("error ", error);
        }
    };

    console.log("Test", servicedataSave);

    const searchItemsSupplier = (event) => {
        let _filteredItems = supplierData?.filter((item) =>
            item?.NAME.toLowerCase().includes(event.query.toLowerCase())
        );
        setSupplierName(_filteredItems);
        setSupplierGstnNo(_filteredItems?.GSTN_NO);
    };

    const searchItemsRSE = (event) => {
        let _filteredItems = supplierData?.filter((item) =>
            item?.NAME.toLowerCase().includes(event.query.toLowerCase())
        );
        setSupplierName(_filteredItems);
        setSupplierGstnNo(_filteredItems?.GSTN_NO);
    };

    const handleChangeSupplier = (e) => {
        setSelectedSupplier(e.value);
        setSupplierGstnNo(e.value.GSTN_NO ?? "");
    };
    const handleChangeRSE = (e) => {
        setSelectedSupplier(e.value);
        setSupplierGstnNo(e.value?.GSTN_NO ?? "");
    };

    const handleSelectRSE = async (e) => {
        console.log("eewwe",e);
        try {
            const response = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.GetPreviousInvoice}?CompId=${auth.CompId}&SupplierId=${e?.value.MASK_SUPP_ID}`
            );
            if (response?.data?.Data.length !== 0) {
                setPrevRSE(true);
                setPrevRSEInv(response?.data.Data[0]);
            }
            else {
                setPrevRSE(false);
            }
        }
        catch (e) {
            console.log("Error", e);
        }
    };

    const searchItemsSSR = (event) => {
        let _filteredItems = SSRData?.filter((item) =>
            item?.NAME?.toLowerCase().includes(event?.query?.toLowerCase())
        );
        setSSRName(_filteredItems);
    };
    const handleChangeSSR = async (e) => {
        setSelectedSSR(e.value);
        if (e.value) {
            try {
                const cnFocurl = "ServiceInvoice/GetSSRDetails?";
                const cnFocCustData = `${cnFocurl}SSRId=${e.value.CODE}`;
                let dataresponse = await Axios.get(cnFocCustData);
                setSelectedSSRdetails(dataresponse.data.Data);

            } catch (error) {
                console.log(error);
            }
        }

    };


    const AddData = async () => {
        // debugger
        if (strType == "S" && !selectedSSR) {
            toast.warn("Please select a SSR.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
        else if (strType === "S" && (startDate.getMonth() !== endDate.getMonth())) {
            toast.warn("Please Select date within the same month.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        else {
            if (strType == "S") {
                const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(
                    startDate
                );
                const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
                if (startDate > endDate) {
                    toast.error("Start date should be less than end date", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    return;
                }
                setLoading(true);
                try {
                    const response = await createAPIEndpointServiceInvoice().get(
                        `${EndpointServiceInvoice.CheckCrossQuarter}?FromDate=${formattedStartDate}&ToDate=${formattedEndDate}`
                    );
                    if (JSON.stringify(response.data.Data).includes("Cross")) {
                        toast.error(response.data.Data[0].MESSAGE, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setLoading(false);
                        return;
                    } else {
                        const res = await createAPIEndpointServiceInvoice().get(
                            `${EndpointServiceInvoice.GetInvoiceCountforSSR}?SSRId=${selectedSSR?.CODE}&FromDate=${formattedStartDate}&ToDate=${formattedEndDate}`
                        );
                        setInvoiceSSRCount(res.data);
                        if (res.data.Data.length > 0) {
                            if (res.data.Data.length == 1) {
                                if (res.data?.Data[0].COUNT > 1) {
                                    toast.error(
                                        "Invoice was raised previously for this SSR in this date range",
                                        {
                                            position: toast.POSITION.TOP_CENTER,
                                            pauseOnFocusLoss: false,
                                            closeButton: false,
                                            autoClose: 3000,
                                        }
                                    );
                                    setLoading(false);
                                    return;
                                }

                            }
                            if (res.data.Data.length == 2) {
                                toast.error(
                                    "Invoice was raised previously for this SSR in this date range",
                                    {
                                        position: toast.POSITION.TOP_CENTER,
                                        pauseOnFocusLoss: false,
                                        closeButton: false,
                                        autoClose: 3000,
                                    }
                                );
                                setLoading(false);
                                return;
                            }
                        }

                        const res1 = await createAPIEndpointServiceInvoice().get(
                            `${EndpointServiceInvoice.SupgeogId}?strSupplierId=${strType == "S" ? selectedSupplierService?.MASK_SUPP_ID : selectedSupplier?.MASK_SUPP_ID}&ServiceType=${strType}`
                        );
                        const res2 = await createAPIEndpointServiceInvoice().get(
                            `${EndpointServiceInvoice.CompgeogId}?strCompId=${auth.CompId}`
                        );
                        if (res1.data.Data[0]?.geog_id != res2.data.Data[0]?.geog_id) {
                            setShowGST(true);
                        }
                        else {
                            setShowGST(false);
                        }
                    }
                    setShowDialog(true);
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                    console.log("error ", err);
                }
            }
        }
        if (strType == "N" || strType === "R") {
            if (selectedSupplier == undefined) {
                toast.warn(`${strType === "R" ? "Please select RSE" : "Please select supplier"}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }
            const res1 = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.SupgeogId}?strSupplierId=${selectedSupplier?.MASK_SUPP_ID}&ServiceType=${strType}`
            );
            const res2 = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.CompgeogId}?strCompId=${auth.CompId}`
            );
            if (res1.data.Data[0]?.geog_id != res2.data.Data[0]?.geog_id) {
                setShowGST(true);
            }
            else {
                setShowGST(false);
            }
            setShowDialog(true);
        }

        if (strType == "R") {
            // if (selectedSupplier == undefined) {
            //     toast.error("Please select supplier", {
            //         position: toast.POSITION.TOP_CENTER,
            //         pauseOnFocusLoss: false,
            //         closeButton: false,
            //         autoClose: 3000,
            //     });
            //     return;
            // }
            const res1 = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.SupgeogId}?strSupplierId=${selectedSupplier?.MASK_SUPP_ID}&ServiceType=${strType}`
            );
            const res2 = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.CompgeogId}?strCompId=${auth.CompId}`
            );
            if (res1.data.Data[0]?.geog_id != res2.data.Data[0]?.geog_id) {
                setShowGST(true);
            }
            else {
                setShowGST(false);
            }
            setShowDialog(true);
        }
    };

    const createPayload = () => {
        const objDetl = allRecordsData.map((item) => ({
            stK_ADJ_ITM_SLNO: item.row.toString(),
            servicE_DETAIL: item.Service_Details,
            amounT_EX_GST: item.Amount_Excluding_GST.toString(),
            sutgsT_PRCNT: item.SGST_UTGST ? item.SGST_UTGST.toString() : "0",
            sutgsT_AMNT: item.SGST_UTGST_Amount.toString(),
            cgsT_PRCNT: item.CGST ? item.CGST.toString() : "0",
            cgsT_AMNT: item.CGST_Amount.toString(),
            igsT_PRCNT: item.IGST ? item.IGST.toString() : "0",
            igsT_AMNT: item.IGST_Amount.toString(),
            toT_AMNT: item.Total_Amount.toString(),
        }));
        return {
            userId: auth.UserId,
            compId: auth.CompId,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvIRPUserPassword: auth.EInvIRPUserPassword,
            eInvGSTNO: auth?.EInvGSTNO,
            invType: strType,
            cmbSupplier: selectedSupplier?.MASK_SUPP_ID,
            SuppId: selectedSupplier?.MASK_SUPP_ID,
            rdtStrtdate: new Intl.DateTimeFormat("en-GB").format(startDate),
            rdtEnddate: new Intl.DateTimeFormat("en-GB").format(endDate),
            cmbSSRCode: selectedSSR?.CODE,
            cmbSSRName: selectedSSR?.NAME,
            objDetl: objDetl,
        };
    };

    const onSubmit = async () => {
        let response;
        if ((strType !== "N" && strType !== "R") && (selectedSSR == null)) {
            toast.warn("Please Select SSR Name.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }
        if (strType === "R") {
            if (prevRSE) {
                setConfirmSaveRSEPopup(true);
            }
            else {
                setLoading(true);
                const payload = createPayload();
                // console.log("Payload", payload);
                try {
                    response = await createAPIEndpointServiceInvoice().post(
                        `${EndpointServiceInvoice.Save}`,
                        payload
                    );
                    toast.success(`${response.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setLoading(false);
                    if (strType !== "R")
                        nav("/salesmanagement/serviceinvoice");
                    if (strType === "R") {
                        setRSEName(selectedSupplier?.NAME2);
                        setInvhId(response?.data?.SIId);
                        setLoading(true);
                        const payload = {
                            invhId: response?.data?.SIId,
                            eInvApplicability: auth?.EInvApplicability,
                            ServiceType: strType
                        };
                        try {
                            const responseprint = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.PrintServiceInv}`, payload);
                            setPrintData(responseprint.data);
                            setShowInvoice(true);
                            setLoading(false);
                            setTag("R");
                        } catch (err) {
                            setLoading(false);
                            console.log("Error ", err);
                        }

                    }
                } catch (error) {
                    setLoading(false);
                    console.log("Error ", error);
                    toast.error(`${error.response.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                }
            }
        }
        else {
            setLoading(true);
            const payload = createPayload();
            // console.log("Payload", payload);
            try {
                response = await createAPIEndpointServiceInvoice().post(
                    `${EndpointServiceInvoice.Save}`,
                    payload
                );
                toast.success(`${response.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                setLoading(false);
                if (strType !== "R")
                    nav("/salesmanagement/serviceinvoice");
                if (strType === "R") {
                    setRSEName(selectedSupplier?.NAME2);
                    setInvhId(response?.data?.SIId);
                    setLoading(true);
                    const payload = {
                        invhId: response?.data?.SIId,
                        eInvApplicability: auth?.EInvApplicability,
                        ServiceType: strType
                    };
                    try {
                        const responseprint = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.PrintServiceInv}`, payload);
                        setPrintData(responseprint.data);
                        setShowInvoice(true);
                        setLoading(false);
                        setTag("R");
                    } catch (err) {
                        setLoading(false);
                        console.log("Error ", err);
                    }

                }
            } catch (error) {
                setLoading(false);
                console.log("Error ", error);
                toast.error(`${error.response.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
            }
        }
    };

    const onConfirm = async () => {
        let response;
        setLoading(true);
        const payload = createPayload();
        // console.log("Payload", payload);
        try {
            response = await createAPIEndpointServiceInvoice().post(
                `${EndpointServiceInvoice.Save}`,
                payload
            );
            toast.success(`${response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            setConfirmSaveRSEPopup(false);
            setLoading(false);
            if (strType !== "R")
                nav("/salesmanagement/serviceinvoice");
            if (strType === "R") {
                setRSEName(selectedSupplier?.NAME2);
                setInvhId(response?.data?.SIId);
                setLoading(true);
                const payload = {
                    invhId: response?.data?.SIId,
                    eInvApplicability: auth?.EInvApplicability,
                    ServiceType: strType
                };
                try {
                    const responseprint = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.PrintServiceInv}`, payload);
                    setPrintData(responseprint.data);
                    setShowInvoice(true);
                    setLoading(false);
                    setTag("R");
                } catch (err) {
                    setLoading(false);
                    console.log("Error ", err);
                }

            }
        } catch (error) {
            setLoading(false);
            console.log("Error ", error);
            toast.error(`${error.response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
    };

    const handleCancel = (rowData) => {
        setAllRecordsData((prevData) => {
            let updatedData;

            if (
                rowData.Service_Details?.trim().toLowerCase() ===
                "business development charges" ||
                rowData.SERVICE_DETAIL?.trim().toLowerCase() ===
                "business development charges"
            ) {
                // Remove BOTH Business Development Charges and Other Development Charges
                updatedData = prevData.filter(
                    (item) =>
                        item.row !== rowData.row &&
                        item.Service_Details?.trim().toLowerCase() !==
                        "other development charges"
                );
            } else {
                // Normal single-row delete
                updatedData = prevData.filter((item) => item.row !== rowData.row);
            }

            // Reindex rows
            const adjustedData = updatedData.map((item, index) => ({
                ...item,
                row: index + 1,
            }));

            return adjustedData;
        });
    };



    useEffect(() => {
        if (strType == "N") {
            getSupplierData();
            setServicedataSave(false);
            setSupplierGstnNo("");
        }
        if (strType == "S") {
            getSupplierDataforService();
            setServicedataSave(true);
            getSSRData();
        }
        if (strType == "R") {
            getRSEData();
            setServicedataSave(true);
            setSupplierGstnNo("");
        }
        setAllRecordsData([]);
    }, [strType]);



    useEffect(() => {
        pageload();
    }, []);

    useEffect(() => {
        if (invhId !== null) {
            let onpageload = async () => {
                const res1 = await createAPIEndpointServiceInvoice().get(
                    `${EndpointServiceInvoice.SupgeogId}?strSupplierId=${strType == "S" ? selectedSupplierService?.MASK_SUPP_ID : selectedSupplier?.MASK_SUPP_ID}&ServiceType=${strType}`
                );
                const res2 = await createAPIEndpointServiceInvoice().get(
                    `${EndpointServiceInvoice.CompgeogId}?strCompId=${auth.CompId}`
                );
                if (res1.data.Data[0]?.geog_id != res2.data.Data[0]?.geog_id) {
                    setShowGST(true);
                }
                else {
                    setShowGST(false);
                }
            };
            onpageload();
        }
    }, [selectedSupplier]);

    const pageload = async () => {
        if (invhId !== null) {
            setDisable(true);
            let responseSSR;
            let responseSupplier;
            let _filteredSupplierName;
            try {
                const response = await createAPIEndpointServiceInvoice().get(
                    `${EndpointServiceInvoice.PopulateSIDetailData}?strInvHdrId=${invhId}`
                );
                setAllRecordsData(response.data.Data);
            } catch (error) {
                console.log("error ", error);
            }
            const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(startdate);
            const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(enddate);
            try {

                const response = await createAPIEndpointServiceInvoice().get(`${EndpointServiceInvoice.GetAllSerInv}?FromDate=${formattedStartDate}&ToDate=${formattedEndDate}&strtype=${strType}&CompId=${auth?.CompId}`);
                const _filteredSSR = response.data.Data?.filter((val) => {
                    return val?.MASK_INVH_ID === invhId;
                });
                try {
                    responseSSR = await createAPIEndpointServiceInvoice().get(
                        `${EndpointServiceInvoice.PopulateSSR}?UserId=${auth.UserId}`
                    );
                    setSSRData(responseSSR.data.Data);
                } catch (error) {
                    console.log("error ", error);
                }
                const _filteredSSRName = responseSSR.data.Data?.filter((val) => {
                    return val?.CODE === _filteredSSR[0].SSR_CODE;
                });
                try {
                    if (strType === "R") {
                        responseSupplier = await createAPIEndpointServiceInvoice().get(
                            `${EndpointServiceInvoice.PopulateRSESupplier}?UserId=${auth.UserId}&CompId=${auth.CompId}`
                        );
                        _filteredSupplierName = responseSupplier.data.Data?.filter((val) => {
                            return val?.NAME2 === _filteredSSR[0].SUPP_NAME;
                        });
                    }
                    else {
                        responseSupplier = await createAPIEndpointServiceInvoice().get(
                            `${EndpointServiceInvoice.PopulateSupplier}?UserId=${auth.UserId}&CompId=${auth.CompId}`
                        );
                        _filteredSupplierName = responseSupplier.data.Data?.filter((val) => {
                            return val?.NAME === _filteredSSR[0].SUPP_NAME;
                        });
                    }
                    setSupplierData(responseSupplier.data.Data);
                } catch (error) {
                    console.log("error ", error);
                }
                // _filteredSupplierName = responseSupplier.data.Data?.filter((val) => {
                //     return val?.NAME === _filteredSSR[0].SUPP_NAME;
                // });

                setSelectedSupplier(_filteredSupplierName[0]);
                setSupplierGstnNo(_filteredSupplierName[0]?.GSTN_NO);
                setSelectedSSR(_filteredSSRName[0]);
                setStartDate(parse(_filteredSSR[0]?.START_DATE, "dd/MM/yyyy", new Date()));
                setEndDate(parse(_filteredSSR[0]?.END_DATE, "dd/MM/yyyy", new Date()));
                setInvoiceDate(format(parse(_filteredSSR[0]?.INVH_DATE, "dd/MM/yyyy", new Date()), "dd/MM/yyyy"));
                setInvoiceNo(_filteredSSR[0]?.INVH_NO);

                setLoading(false);
            } catch (err) {
                console.log("Error ", err);
                setLoading(false);
            }
        }
        else {
            setDisable(false);
        }
        if (allRecordsData.some((val) => val?.Service_Details === "Other Development Charges")) {
            setDisable(true);
        }
    };

    if (loading) {
        return (
            <Loader />
        );
    }
    else {
        return (
            <div className="col-12 pt-0 pb-4">
                <div className="row d-flex justify-content-center align-items-center mb-3">
                    <div className="col-lg-3 col-md-12 col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mx-1 mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/salesmanagement/serviceinvoice">
                                        Service Invoice
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <form>
                            <div className="d-flex justify-content-center">
                                <div className="d-inline-flex">
                                    <RadioButton
                                        name="Type"
                                        value="Normal Service Invoice"
                                        onChange={() => {
                                            setStrType("N");
                                            setSelectedSupplier(null);
                                            // GetAllRecordsofCustomerForReactivation(e.value);
                                            // setActiveIndex(0);
                                        }}
                                        disabled={disable}
                                        checked={strType === "N"}
                                    />
                                    <label className="mx-2">Normal Service Invoice</label>
                                    <RadioButton
                                        name="Type"
                                        value="SSR Service Invoice"
                                        onChange={() => {
                                            setStrType("S");
                                            // GetAllRecordsofCustomerForReactivation(e.value);
                                            // setActiveIndex(0);
                                        }}
                                        disabled={disable}
                                        checked={strType === "S"}
                                    />
                                    <label className="mx-2">SSR Service Invoice</label>
                                    <RadioButton
                                        name="Type"
                                        value="RSE Service Invoice"
                                        onChange={() => {
                                            setStrType("R");
                                            setSelectedSupplier(null);
                                            // GetAllRecordsofCustomerForReactivation(e.value);
                                            // setActiveIndex(0);
                                        }}
                                        disabled={disable}
                                        checked={strType === "R"}
                                    />
                                    <label className="mx-2">RSE Service Invoice</label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="text-end">
                            <Link to="/salesmanagement/serviceinvoice">
                                <button type="submit" className="btn btn-primary">
                                    <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                                    Records
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>

                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Invoice Number <span className="mandatory">*</span>
                                </label>
                                <InputText
                                    className="form-control"
                                    value={invoiceNo}
                                    disabled
                                    required
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    Invoice Date <span className="mandatory">*</span>
                                </label>
                                <InputText
                                    className="form-control"
                                    value={invoiceDate}
                                    required
                                    disabled
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    {strType == "R" ? "RSE Name" : "Supplier Name"} <span className="mandatory">*</span>
                                </label>
                                {strType == "S" ? (
                                    <AutoComplete
                                        dropdown
                                        value={selectedSupplierService}
                                        field="NAME"
                                        disabled
                                        required
                                    />
                                ) : strType == "N" ? (
                                    <AutoComplete
                                        dropdown
                                        value={selectedSupplier}
                                        suggestions={supplierName}
                                        completeMethod={searchItemsSupplier}
                                        field="NAME"
                                        onChange={handleChangeSupplier}
                                        onSelect={handleSelectRSE}
                                        required
                                        disabled={disable}
                                        forceSelection
                                    />
                                ) : (
                                    <AutoComplete
                                        dropdown
                                        value={selectedSupplier}
                                        suggestions={supplierName}
                                        completeMethod={searchItemsRSE}
                                        field="NAME"
                                        onChange={handleChangeRSE}
                                        onSelect={handleSelectRSE}
                                        required
                                        disabled={disable}
                                        forceSelection
                                    />
                                )
                                }
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                                <label className="form-label">
                                    {strType == "R" ? "RSE GSTN Number" : "Supplier GSTN Number"} {strType !== "R" && <span className="mandatory">*</span>}
                                </label>
                                {strType == "S" ? (
                                    <InputText
                                        className="form-control"
                                        value={supplierGstnNoService}
                                        disabled
                                    />
                                ) : strType == "N" ? (
                                    <InputText
                                        className="form-control"
                                        value={supplierGstnNo}
                                        disabled
                                        required
                                    />
                                ) : (
                                    <InputText
                                        className="form-control"
                                        value={supplierGstnNo}
                                        disabled
                                        required
                                    />
                                )
                                }
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="float-end">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary me-3"
                                        onClick={AddData}
                                        disabled={disable}
                                    >
                                        Add Row
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={onSubmit}
                                        disabled={allRecordsData.length == 0 || disable}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                {strType == "S" && (
                    <section className="sales-box">
                        <form>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        SSR Name <span className="mandatory">*</span>
                                    </label>
                                    <AutoComplete
                                        dropdown
                                        value={selectedSSR}
                                        suggestions={SSRName}
                                        completeMethod={searchItemsSSR}
                                        field="NAME"
                                        onChange={handleChangeSSR}
                                        required
                                        disabled={disable}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Start Date <span className="mandatory">*</span>
                                    </label>
                                    <Calendar
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.value)}
                                        showIcon
                                        required
                                        dateFormat="dd/mm/yy"
                                        disabled={disable}
                                        maxDate={new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        End Date <span className="mandatory">*</span>
                                    </label>
                                    <Calendar
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.value)}
                                        showIcon
                                        required
                                        dateFormat="dd/mm/yy"
                                        disabled={disable}
                                        maxDate={new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)}
                                    />
                                </div>
                            </div>
                        </form>
                    </section>
                )}
                <section className="">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3>Records</h3>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <div className="DataTable pb-4 pt-1">
                                <DataTable
                                    value={allRecordsData}
                                    rows={10}
                                    // showGridlines
                                    paginator
                                    stripedRows
                                    scrollHeight="80vh"
                                    scrollable
                                    tableStyle={{ minWidth: "100rem" }}
                                >
                                    <Column
                                        header="Service Details"
                                        body={(rowData) => rowData?.Service_Details || rowData?.SERVICE_DETAIL || "-"}
                                    />
                                    <Column
                                        header="Amount Excluding GST"
                                        body={(rowData) => rowData?.Amount_Excluding_GST || rowData?.AMOUNT_EX_GST || "0"}
                                    />
                                    {!showGST && <Column
                                        header="SGST/ UTGST %"
                                        body={(rowData) => rowData?.SGST_UTGST || rowData?.SUTGST_PRCNT || "0"}
                                    />}
                                    {!showGST && <Column
                                        header="SGST/ UTGST Amount"
                                        body={(rowData) => rowData?.SGST_UTGST_Amount || rowData?.SUTGST_AMNT || "0"}
                                    />}
                                    {!showGST && <Column
                                        header="CGST %"
                                        body={(rowData) => rowData?.CGST || rowData?.CGST_PRCNT || "0"}
                                    />}
                                    {!showGST && <Column
                                        header="CGST Amount"
                                        body={(rowData) => rowData?.CGST_Amount || rowData?.CGST_AMNT || "0"}
                                    />}
                                    {showGST && <Column
                                        header="IGST %"
                                        body={(rowData) => rowData?.IGST || rowData?.IGST_PRCNT || "0"}
                                    />}
                                    {showGST && <Column
                                        header="IGST Amount"
                                        body={(rowData) => rowData?.IGST_Amount || rowData?.IGST_AMNT || "0"}
                                    />}
                                    <Column
                                        header="Total Amount"
                                        body={(rowData) => rowData?.Total_Amount || rowData?.TOT_AMNT || "0"}
                                    />
                                    {!disable && (
                                        <Column
                                            header="Action"
                                            body={(rowData) => {
                                                const service = rowData?.Service_Details?.trim().toLowerCase();
                                                if (service === "other development charges") {
                                                    return null; // ✅ no icon shown
                                                }
                                                return (
                                                    <i
                                                        className="pi pi-times"
                                                        style={{ color: "red", cursor: "pointer" }}
                                                        onClick={() => handleCancel(rowData)}
                                                    ></i>
                                                );
                                            }}
                                        />
                                    )}

                                </DataTable>
                            </div>
                        </div>
                    </div>
                </section>
                <Dialog
                    header="Information"
                    visible={confirmSaveRSEPopup}
                    style={{ width: "50vw" }}
                    // onHide={() => setSurePopup(false)}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div>
                        <p className="mb-0">
                            RSE Invoice with Invoice No. {prevRSEInv?.INVH_NO} dated {prevRSEInv?.INVH_DATE} already exist. Are you sure you want to continue?
                        </p>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="float-end">
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={() => onConfirm()}
                            >
                                OK
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={() => {
                                    setConfirmSaveRSEPopup(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </Dialog>
                <ServiceInvoice DCpopup={showInvoice} setDCPopup={setShowInvoice} printData={printData} tag={Tag} invhid={InvhId} strType={strType} rseName={RSEName} />
                {showDialog && (
                    <Information
                        showDialog={showDialog}
                        setShowDialog={setShowDialog}
                        supplierName={selectedSupplier}
                        strType={strType}
                        showGST={showGST}
                        allRecordsData={allRecordsData}
                        setAllRecordsData={setAllRecordsData}
                        invoiceSSRCount={invoiceSSRCount}
                        startDate={startDate}
                        endDate={endDate}
                        selectedSSRdetails={selectedSSRdetails}
                        selectedSSR={selectedSSR}
                    />
                )}
            </div>
        );
    }
};

export default ServiceInvoiceDetails;
